$('.reviews-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 50000,
    speed: 500,
    cssEase: 'linear',
    touchThreshold: 90,
    prevArrow: $('.reviews-left'),
    nextArrow: $('.reviews-right')
})